"use strict";

jQuery(document).ready(function ($) {
  $('.faqs__arrow').on('click', function () {
    var faqItem = $(this).closest('.faqs__item');
    if (faqItem.is(':focus')) {
      faqItem.trigger('blur');
    }
  });
  $('.faqs__close').on('click', function () {
    var faqItem = $(this).closest('.faqs__item');
    if (faqItem.is(':focus')) {
      faqItem.trigger('blur');
      faqItem.get(0).scrollIntoViewIfNeeded({
        behavior: 'smooth'
      });
    }
  });
});